define([
    'common/ui/view/svg/index',
    'common/ui/view/svg/icon',
    'common/ui/view/svg/shape/factory',
    'common/ui/view/svg/util',
    'common/ui/view/svg/mark/index',
    'common/ui/view/svg/collection',
    'd3',
    'victor'
], function(
    SVGView,
    IconView,
    ShapeFactory,
    SVGUtil,
    Mark,
    CollectionView,
    d3,
    Victor
    ) {
    var NodeView = SVGView.extend({
        locator: null,
        shapeViewClass: 'circle',
        shapeViewOptions: {r: 128},
        label: '',
        content: null,
        syncState: null,
        portViewClass: null,
        portViewOptions: function() {
            return {
                nodeView: this
            }
        },
        ports: null,

        initialize: function(params) {
            NodeView.__super__.initialize.call(this, params);
            this.shapeView = null;
            this.listenTo(this.getSyncState(), 'change',
                this.renderSyncState);
        },

        onRender: function() {
            NodeView.__super__.onRender.call(this);
            this.calcPos();
            this.renderShape();
            this.renderLabel();
            this.renderContent();
            this.renderSyncState();
            this.renderPorts();
            this.$el
                .attr('transform', SVGUtil.transform(this._getCenterPoint().toObject()));
        },

        getShapeView: function() {
            var viewClass = null;
            if(_.isFunction(this.shapeViewClass)) {
                viewClass = this.shapeViewClass();
            } else {
                viewClass = this.shapeViewClass;
            }
            if(_.isString(viewClass)) {
                viewClass = ShapeFactory.find(viewClass);
            }
            return viewClass;
        },

        getShapeViewOptions: function() {
            if(_.isFunction(this.shapeViewOptions)) {
                return this.shapeViewOptions();
            } else {
                return this.shapeViewOptions;
            }
        },

        buildShapeView: function() {
            var viewClass = this.getShapeView();
            return new viewClass(this.getShapeViewOptions());
        },

        getPortViewClass: function() {
            var viewClass = null;
            // if(_.isFunction(this.portView)) {
            //     viewClass = this.portView();
            // } else {
            //     viewClass = this.portView;
            // }
            // return viewClass;
            return this.portViewClass;
        },

        getPortViewOptions: function() {
            if(_.isFunction(this.portViewOptions)) {
                return this.portViewOptions();
            } else {
                return this.portViewOptions;
            }
        },

        getLabel: function() {
            if(_.isFunction(this.label)) {
                return this.label();
            } else {
                return this.label;
            }
        },

        getContent: function() {
            if(_.isFunction(this.content)) {
                return this.content();
            } else {
                return this.content;
            }
        },

        getPorts: function() {
            if(_.isFunction(this.ports)) {
                return this.ports();
            } else {
                return this.ports;
            }
        },

        getSyncState: function() {
            if(_.isFunction(this.syncState)) {
                return this.syncState();
            } else {
                return this.syncState;
            }
        },

        getBorderPoint: function(direction, offset) {
            if(_.isNumber(direction)) {
                direction = Victor(1, 0).rotateDeg(-direction);
            }
            var p = this.shapeView.getBorderPoint(direction, offset);
            return p.add(this.getCenterPoint());
        },

        getBorderTangent: function(direction, offset) {
            if(_.isNumber(direction)) {
                direction = Victor(1, 0).rotateDeg(-direction);
            }
            return this.shapeView.getBorderTangent(direction, offset);
        },

        _getCenterPoint: function() {
            return this.pos.clone();
        },

        getCenterPoint: function() {
            return this._getCenterPoint();
        },

        calcPos: function() {
            this.pos = Victor.fromObject(this.locator());
        },

        onDrag: function(pos, dpos) {
            this.pos.add(dpos);
            this.$el
                .attr('transform', SVGUtil.transform(this._getCenterPoint().toObject()));
            this.trigger('move');
        },

        onDragEnd: function(pos) {
            this.trigger('move');
        },

        renderShape: function() {
            if(this.shapeView) {
                this.shapeView.remove();
            }
            this.shapeView = this.buildShapeView();
            this.$el.append(this.shapeView.render().el);
            this.shapeView.$el.classed('node-shape', true);
        },

        renderLabel: function() {
            if(this.labelView) {
                this.labelView.remove();
            }
            if(!this.getLabel()) {
                return;
            }
            this.labelView = this.shapeView.createTextpath({
                id: 'label-' + this.model.id
            });
            this.$el.append(this.labelView.render().el);
            this.labelView.$el.classed('node-label', true);
            this.labelView.text(this.getLabel());
        },

        renderContent: function() {
            if(this.contentView) {
                this.contentView.remove();
            }
            if(!this.getContent()) {
                return;
            }
            this.contentView = this.shapeView.createTextArea();
            this.$el.append(this.contentView.render().el);
            this.contentView.$el.classed('node-content', true);
            this.contentView.text(this.getContent());
        },

        renderPorts: function() {
            // Port View か Port が指定されていない場合は port を rendering しない
            if(!this.getPortViewClass() || !this.getPorts()) {
                return;
            }
            if(this.portsView) {
                this.$el.append(this.portsView.el);
                return;
            }
            var PortsView = CollectionView.extend({
                className: 'ports',
                childView: this.getPortViewClass(),
                childViewOptions: _.bind(this.getPortViewOptions, this)
            });
            var portsView = new PortsView({
                collection: this.getPorts()
            });
            this.portsView = portsView;
            this.$el.append(portsView.render().el);
        },

        getPortView: function(model) {
            return this.portsView.children.findByModel(model);
        },

        renderSyncState: function() {
            var state = this.getSyncState();
            if(!state) {
                return;
            }
            var faclass = null;
            if(state.isUnsync()){
                faclass = 'fa fa-save';
            } else if (state.isSyncing()) {
                faclass = 'fa fa-refresh';
            } else if (state.isConflict()) {
                faclass = 'fa fa-exclamation text-danger';
            }

            this.$el.selectAll('.node-sync').remove();
            if(faclass) {
                var direction = Victor(1, 0).rotateDeg(-45);
                var pos = this.shapeView.getBorderPoint(direction, 0);
                var syncState = this.$el.append('g')
                    .classed('node-sync', true)
                    .attr('transform', SVGUtil.transform(pos));

                syncState.append('circle')
                    .attr('r', 40)
                    .attr('cx', 0)
                    .attr('cy', 0);

                var icon = new IconView({
                    class: faclass,
                    offset: {x: 0, y: 0},
                    size: 48
                });
                syncState.append(icon.render().el);

                if (state.isSyncing()) {
                    var rotate = function(angle) {
                        angle = angle + 120;
                        icon.$el.transition()
                            .duration(1000)
                            .ease(d3.easeLinear)
                            .attr('transform', `rotate(${angle})`)
                            .on('end', function(){rotate(angle)});
                    };
                    rotate(0);
                }
            }
        },

        onClickLinker: function(pos) {},

        renderLinker: function(angle) {
            this.removeLinker();
            var cssClass = 'node-linker';
            var direction = Victor(1, 0).rotateDeg(-angle);
            var pos = this.shapeView.getBorderPoint(direction, 100);
            var g = this.$el.append('g')
                .attr('transform', SVGUtil.transform(pos))
                .classed(cssClass, true)
                .style('opacity', 0.0);
            g.transition()
                .duration(300)
                .style('opacity', 0.5);

            // 外側の円
            g.append('circle')
                .attr('r', 32)
                .attr('stroke-width', 16);

            // 矢印のマーク
            var mark = g.append('g')
                .classed('node-linker-mark', true);

            var m = new Mark({
                type: 'triangle',
                size: 0.8,
                offset: {
                    y: -10
                }
            });
            mark.append(m.render().el);

            mark.append('rect')
                .attr('width', 12)
                .attr('height', 32)
                .attr('x', -6);

            mark.attr('transform',
                SVGUtil.transform({x:0, y: 0, rotate: - angle - 90}));

            var stopEvent = function() {
                d3.event.stopPropagation();
                d3.event.preventDefault();
            };
            g.on('mouseover', function() {
                g.style('opacity', 0.8);
                stopEvent();
            });
            g.on('mouseout', function() {
                g.style('opacity', 0.5);
                stopEvent();
            });
            g.on('mousedown', stopEvent);
            g.on('click', stopEvent);

            var self = this;
            g.on('mouseup', function() {
                var pos = Victor.fromObject(SVGUtil.getEventPos());
                self.onClickLinker(pos);
                d3.event.stopPropagation();
            });
        },

        removeLinker: function() {
            this.$el.selectAll('.node-linker')
                .transition()
                .duration(300)
                .style('opacity', 0)
                .remove();
        },

        renderImage: function(url) {
            this.removeImage();
            var id = 'image-id-' + this.model.id;
            this.imageDef = this.$el
                .append('svg:defs')
                .append('svg:pattern')
                .attr('width', this.shapeView.imageSize())
                .attr('height', this.shapeView.imageSize())
                .attr('x', this.shapeView.imageOffset().x)
                .attr('y', this.shapeView.imageOffset().y)
                .attr('patternUnits', "userSpaceOnUse")
                .attr('id', id)
                .append('image')
                .attr('width', this.shapeView.imageSize())
                .attr('height', this.shapeView.imageSize())
                .attr('xlink:href', url);

            this.shapeView.setImage(id);
        },

        removeImage: function() {
            if(this.imageDef) {
                this.imageDef.remove();
            }
            this.shapeView.setImage(null);
        }
    });

    return NodeView;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/node.js